export function stripInlineBackgroundStyles(html: string): string {
  if (typeof document === "undefined") return html;
  try {
    const tpl = document.createElement("template");
    tpl.innerHTML = html;
    tpl.content.querySelectorAll("[style]").forEach((node) => {
      const el = node as HTMLElement;
      el.style.removeProperty("background");
      el.style.removeProperty("background-color");
      el.style.removeProperty("background-image");
      el.style.removeProperty("font-family");
      el.style.removeProperty("font-size");
      el.style.removeProperty("font-weight");
      el.style.removeProperty("letter-spacing");
      el.style.removeProperty("line-height");
      el.style.removeProperty("color");
      el.style.removeProperty("text-align");
      el.style.removeProperty("text-decoration");
      el.style.removeProperty("text-transform");
      el.style.removeProperty("text-indent");
      el.style.removeProperty("text-shadow");
      el.style.removeProperty("text-overflow");
      el.style.removeProperty("text-overflow-wrap");
      const remaining = el.getAttribute("style");
      if (!remaining?.trim()) {
        el.removeAttribute("style");
      }
    });
    return tpl.innerHTML;
  } catch {
    return html;
  }
}

export function ensureSpaceAfterMathML(html: string): string {
  return html.replace(/<\/math>([A-Za-z])/g, "</math> $1");
}

export function unwrapStrongAndBold(html: string): string {
  if (typeof document === "undefined") return html;
  try {
    const tpl = document.createElement("template");
    tpl.innerHTML = html;
    const root = tpl.content;
    const tags = root.querySelectorAll("strong, b");
    const list = Array.from(tags).sort((a, b) => {
      const da = a.querySelectorAll("strong, b").length;
      const db = b.querySelectorAll("strong, b").length;
      return da - db;
    });
    for (const el of list) {
      const parent = el.parentNode;
      if (!parent) continue;
      while (el.firstChild) {
        parent.insertBefore(el.firstChild, el);
      }
      parent.removeChild(el);
    }
    return tpl.innerHTML;
  } catch {
    return html;
  }
}
